const check = {
  needEvidence (data) {
    if (data.hasOwnProperty('needEvidence')) {
      return data.needEvidence
    }
  },
  needLocalFile (data) {
    if (data.hasOwnProperty('localFile')) {
      return data.localFile
    }
  },
  result (data) {
    let results = {}
    results.needEvidence = this.needEvidence(data)
    if (results.needEvidence) {
      results.needLocalFile = this.needLocalFile(data)
      if (results.needLocalFile) {
        return results
      }
    }
    return false
  },
  questions (questions) {
    let results = []
    questions.forEach((question, questionIndex) => {
      if (question.type === 'select') {
        question.options.forEach((option, optionIndex) => {
          let _result = this.result(option)
          if (_result) {
            results.push(Object.assign({question, questionIndex, option, optionIndex}, _result))
          }
        })
      } else {
        let _result = this.result(question)
        if (_result) {
          results.push(Object.assign({question, questionIndex}, _result))
        }
      }
    })
    return results
  },
}

export default check



// WEBPACK FOOTER //
// ./src/views/question-editor/utils/validate.js